import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Typography from 'web-library/stories/atom/Typography/Typography';

const useStyles = makeStyles()((theme) =>
({
  errorTitle: {
    color: theme.color.text.textHeader,
  },
}));

const ErrorPageTitle = ({ label }: { label: string }) => {
  const { classes } = useStyles();

  return (
    <Typography className={classes.errorTitle} variant="h1">
      {label}
    </Typography>
  );
};

export default ErrorPageTitle;
